import { __awaiter, __decorate } from "tslib";
import { ChangeDetectorRef, Component, Directive, HostListener, Input, OnChanges, OnInit, SimpleChanges, ViewChild, ViewEncapsulation } from '@angular/core';
import { SharedHttp } from '../../services/http-client.service';
import { WebClientService } from '../../services/webclient-settings.service';
import { WebsiteThemeService } from '../../services/website-theme.service';
import { DomSanitizer } from '@angular/platform-browser';
import { QrScannerModalComponent } from '../qr-scanner-modal';
import { QrScannerModalService } from '../qr-scanner-modal/qr-scanner-modal.service';
import { ComponentService } from '../../services/component.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { AuthService } from '../../services/auth.service';
import { Router } from "@angular/router";
import { UpdateUserDataModalComponent } from '../update-user-data-modal/update-user-data-modal.component';
import { DocumentExpirationModalComponent } from "../documentation/document-expiration-modal/document-expiration-modal.component";
import { UtilityService } from "../../services/utility.service";
import { BuySellInfoModalComponent } from "../buy-sell-info-modal/buy-sell-info-modal.component";
import { BankaccountWhitelistInfoExchangeComponent } from "../bankaccount-whitelist-info-exchange/bankaccount-whitelist-info-exchange.component";
import { TranslateObjectPipe } from "../../pipes/translate-object.pipe";
/**
 * Order Form Component
 */
let OrderFormComponent = class OrderFormComponent {
    constructor(httpClient, webSettingsService, themeService, sanitizer, router, qrScannerService, compService, deviceService, changeDetector, auth, utilityService, translateObject) {
        this.httpClient = httpClient;
        this.webSettingsService = webSettingsService;
        this.themeService = themeService;
        this.sanitizer = sanitizer;
        this.router = router;
        this.qrScannerService = qrScannerService;
        this.compService = compService;
        this.deviceService = deviceService;
        this.changeDetector = changeDetector;
        this.auth = auth;
        this.utilityService = utilityService;
        this.translateObject = translateObject;
        this.txData = {};
        this.couponError = false;
        this.couponMessage = '';
        this.couponLimit = '';
        this.activeAccounts = false;
        this.activeAccountsBank = false;
        this.validBankAccount = true;
        this.checkedIfBankAccountIsValid = true;
        this.validDepositAddress = true;
        this.shouldSave = false;
        this.textColor = '';
        this.errorColor = '';
        this.mainColor = '';
        this.inputBackColor = '';
        this.accentColor = '';
        this.settingsValue = '';
        this.validTotalAndAmount = true;
        this.bchAddressError = false;
        this.borderRadiusSmaller = '';
        this.inputTotalFieldColor = '';
        this.deviceInfo = null;
        this.isMobile = false;
        this.isTablet = false;
        this.isDesktopDevice = false;
        this.couponOk = false;
        this.minFeeApplied = false;
        this.orderData = {};
        this.isCompany = false;
        this.user = {};
        this.loggedIn = false;
        this.languageValues = {};
        this.showWarningBanner = false;
        this.newDataPopulated = false;
        this.block_transactions = false;
        this.pending_for_document = false;
        this.eataandpoaosPopulated = false;
        this.feesLimits = {};
        this.decimalStep = '';
        this.defaultDecimalPlaces = 8;
        this.defaultCurrency = localStorage.getItem('defaultCurrency');
        this.fiatWalletChosen = false;
        this.activeChains = false;
        this.chainError = false;
        this.selectedChain = '';
        this.selectedChainName = '';
        this.cryptoAccountsFiltered = {};
        this.someoneElsesAddresses = [];
        this.bankAccountObj = {};
        this.bankAccountValue = '';
        this.waitingForApprovalStatus = 'WAITING_FOR_APPROVAL';
        this.decimalStepFiat = '';
        this.user = JSON.parse(localStorage.getItem('user'));
        this.isIndividual = this.user.is_company_user ? 0 : 1;
        this.auth.getStatus().subscribe((result) => {
            this.loggedIn = result;
            if (this.user) {
                this.isCompany = this.user.is_company_user == 1 ? true : false;
            }
        });
        const lang = localStorage.getItem('language');
        this.getBankAccountSettings(lang);
        this.themeService.getTheme().subscribe((data) => {
            this.textColor = this.themeService.getStyleAttribute('text_color');
            this.errorColor = this.themeService.getStyleAttribute('error_color');
            this.mainColor = this.themeService.getStyleAttribute('main_color');
            this.inputBackColor = this.themeService.getStyleAttribute('input_background_color');
            this.borderRadiusSmaller = this.themeService.getStyleAttribute('border_radius_smaller');
            this.inputTotalFieldColor = this.themeService.getStyleAttribute('input_total_field_color');
            this.accentColor = this.themeService.getStyleAttribute('accent_color');
        });
        this.qrScannerService.getScanResult().subscribe((result) => {
            if (!this.isCompany) {
                if (typeof result !== 'undefined' && result !== null) {
                    let arr;
                    let address;
                    if (result.indexOf(':') !== -1) {
                        arr = result.split(':');
                        address = arr[1];
                    }
                    else {
                        address = result;
                    }
                    if (address.indexOf('?') !== -1) {
                        arr = address.split('?');
                        address = arr[0];
                    }
                    this.fillData(address, 'buy');
                    this.qrScannerService.scanDone(null);
                }
            }
        });
        this.deviceType();
        this.last = new Date().getTime();
        this.webSettingsService.getSettings().subscribe(data => {
            this.minFeeMessageVisible = this.webSettingsService.applySettings('ORDER_MIN_FEE_MESSAGE.VISIBLE');
            this.allowedDecimalPlacesFiat = this.webSettingsService.getCustomValue('FIAT_CURRENCY_LOT_SIZE') ? this.webSettingsService.getCustomValue('FIAT_CURRENCY_LOT_SIZE') : 2;
            for (let i = 1; i <= this.allowedDecimalPlacesFiat; i++) {
                this.decimalStepFiat += i != this.allowedDecimalPlacesFiat ? '0' : '1';
            }
        });
    }
    ngOnInit() {
        var region = this.webSettingsService.getWebSetting('APP_REGION');
        this.newDataPopulated = JSON.parse(localStorage.getItem('user')).newDataPopulated;
        this.block_transactions = JSON.parse(localStorage.getItem('user')).block_transactions;
        this.pending_for_document = JSON.parse(localStorage.getItem('user')).pending_for_document;
        this.eataandpoaosPopulated = JSON.parse(localStorage.getItem('user')).eataandpoaosPopulated;
        if (region != 'EU') {
            if (!this.newDataPopulated || !this.eataandpoaosPopulated) {
                this.compService.openModal(UpdateUserDataModalComponent, { context: 'exchange' });
            }
            else if (this.block_transactions || this.pending_for_document) {
                this.compService.openModal(DocumentExpirationModalComponent, { context: 'exchange' });
            }
            else if (this.webSettingsService.applySettings(this.txType.toUpperCase() + '.' + this.currency.toUpperCase() + '_INFO_MODAL.VISIBLE')) {
                this.compService.openModal(BuySellInfoModalComponent, {
                    txType: this.txType,
                    currency: this.currency
                });
            }
        }
        else {
            if (this.webSettingsService.applySettings(this.txType.toUpperCase() + '.' + this.currency.toUpperCase() + '_INFO_MODAL.VISIBLE')) {
                this.compService.openModal(BuySellInfoModalComponent, {
                    txType: this.txType,
                    currency: this.currency
                });
            }
        }
        this.languageValues = this.webSettingsService.getLanguageFile();
        this.showWarningBanner = this.languageValues['ORDER.WARNING_BANNER_' + this.currency.toUpperCase()] && this.languageValues['ORDER.WARNING_BANNER_' + this.currency.toUpperCase()] !== '';
        // Get market fee required for calculations
        this.httpClient.get('order/marketfee').subscribe((data) => {
            this.marketFee = data['message'];
        });
        this.getLotSizeIfMarketIsBinance();
        if (this.ecurrencyChains.length > 1) {
            this.txData.chainMandatory = true;
            const defaultChain = this.ecurrencyChains.find(chain => chain.is_default) || this.ecurrencyChains[0];
            this.fillChainData(defaultChain);
        }
        else if (this.ecurrencyChains.length === 1 && this.numOfChains > 1) {
            this.fillChainData(this.ecurrencyChains[0]);
        }
        else {
            this.txData.ecurrencyChain = this.ecurrencyChains[0];
            this.cryptoAccountsFiltered = this.cryptoAccounts ? this.cryptoAccounts.filter(account => account.chain_id === this.txData.ecurrencyChain.chain.id) : [];
        }
        this.getWallets();
    }
    ngOnChanges(changes) {
        if (changes.someoneElsesAddressError) {
            this.someoneElsesAddresses.push(this.txData.deposit_address ? this.txData.deposit_address : this.txData.bank_account);
        }
    }
    onResize(event) {
        this.deviceType();
        this.changeDetector.detectChanges();
    }
    deviceType() {
        this.deviceInfo = this.deviceService.getDeviceInfo();
        this.isMobile = this.deviceService.isMobile();
        this.isTablet = this.deviceService.isTablet();
        this.isDesktopDevice = this.deviceService.isDesktop();
    }
    openQRScanner() {
        this.compService.openModal(QrScannerModalComponent, {
            enableScanner: true
        });
    }
    onChange(what, event = null, chainChanged = false) {
        return __awaiter(this, void 0, void 0, function* () {
            this.whatLast = what;
            let numberEntered = this.txData.total;
            let discountPercent = 0;
            let price = this.price.rsd_price;
            let usdRate = this.price.usd_rate;
            let fixedDecimals = this.allowedDecimalPlaces;
            if (this.txData.discount_code) {
                let verifyDiscount = yield this.verifyDiscount();
                if (typeof this.couponValue !== 'undefined' || this.couponValue !== null) {
                    discountPercent = this.couponValue;
                }
            }
            else {
                this.couponError = false;
            }
            // Sell calculations
            if (what === 'amount') {
                // Sell price with market fee need to check is this going to be used
                //if(this.orderSellPrice != '') price = this.orderSellPrice * usdRate;
                // Get values from form and settings
                let currencyPrice = price;
                let fixedProvision = this.fixedFee;
                let feePercent = this.provision;
                let amountFromForm = this.txData.amount;
                const result = yield this.feeCalculation(what, event, chainChanged);
                this.minFee = result ? result['fee'] : this.minFee;
                this.minFeeApplied = result ? result['min_fee_applied'] : this.minFeeApplied;
                let minimalProvision = this.minFee;
                let marketFee = this.marketFee;
                let selectPrice = 0;
                // Get market fee from settings
                if (this.marketFee) {
                    marketFee = this.marketFee;
                }
                if (marketFee > 0 && marketFee < 100) {
                    marketFee = 100 - marketFee;
                }
                // Pevent zero in calculation
                if (marketFee == 0) {
                    marketFee = 1;
                }
                // Step 1: ProcenatProvizijeBezPopusta (ProcenatProvizije - ProcenatPopusta)
                let provisionWithoutDiscountPercent = feePercent - discountPercent;
                // Step 2: Proveriti da li je ProcenatProvizijeBezPopusta manji od 0
                if (provisionWithoutDiscountPercent < 0) {
                    provisionWithoutDiscountPercent = 0;
                }
                // Step 3: VrednostKupovine (IznosSaForme * CurrencyPrice)
                let purshaseAmount = amountFromForm * currencyPrice;
                // Step 4: VrednostKupovineBezMarketFeeja (VrednostKupovine/100 * (100 - marketFee))
                let purshaseAmountWithoutMarketFee = purshaseAmount / 100 * marketFee;
                // Step 5: VrednostProvizijeBezFiksneProvizije (VrednostKupovineBezMarketFeeja/100 * ProcenatProvizijeBezPopusta)
                let provisionAmountWithoutFixedFee = purshaseAmountWithoutMarketFee / 100 * provisionWithoutDiscountPercent;
                // Step 6: UkupnaProvizija (VrednostProvizijeBezFiksneProvizije + FiksnaProvizija)
                let provisionTotal = provisionAmountWithoutFixedFee + fixedProvision;
                // Step 7: PrimenjenaProvizija (Vece od UkupnaProvizija ili MinimalnaProvizija)
                let provisionApplied = provisionTotal;
                if (minimalProvision > provisionTotal) {
                    provisionApplied = minimalProvision;
                    selectPrice = 1;
                }
                // Step 8: TotalKojiDobijaKorisnik (VrednostKupovineBezMarketFeeja - PrimenjenaProvizija)
                let whatUserGet = purshaseAmountWithoutMarketFee - provisionApplied;
                // PShow amount on screen
                let screenTotal = (whatUserGet).toFixed(0);
                if (parseInt(screenTotal) > 0) {
                    this.txData.totalForScreen = screenTotal;
                }
                else {
                    this.txData.totalForScreen = 0;
                }
                // Pass the value for API
                this.txData.total = screenTotal;
                // Pass fee value for screen
                this.txData.appliedFee = provisionApplied;
                // Pass fixed fee value for screen
                this.txData.fixedFee = this.fixedFee;
                // Set price for email
                let priceForEmail = 0;
                if (selectPrice == 0) {
                    // Step 9: CenaZaEmailAkoJeMinimalnaProvizijaManja ((VrednostKupovineBezMarketFeeja - VrednostProvizijeBezFiksneProvizije) / IznosSaForme)
                    priceForEmail = (purshaseAmountWithoutMarketFee - provisionAmountWithoutFixedFee) / amountFromForm;
                }
                else {
                    // Step 9: CenaZaEmailAkoJeMinimalnaProvizijaVeca (VrednostKupovine / IznosSaForme)
                    priceForEmail = purshaseAmount / amountFromForm;
                }
            }
            // Reverse sell calculations
            if (what === 'sell-reverse') {
                // Iznos Sa Forme
                let enteredAmount = this.txData.totalForScreen;
                let currencyPrice = price;
                let fixedProvision = this.fixedFee;
                let feePercent = this.provision;
                let minimalProvision = this.minFee;
                let marketFee = this.marketFee;
                this.txData.total = enteredAmount;
                // Step 0: ProcenatProvizijeBezPopusta (ProcenatProvizije - ProcenatPopusta)
                let provisionWithoutDiscountPercent = feePercent - discountPercent;
                // Step 1: Proveriti da li je ProcenatProvizijeBezPopusta manji od 0
                if (provisionWithoutDiscountPercent < 0) {
                    provisionWithoutDiscountPercent = 0;
                }
                // Pokusaj prvo kakulaciju sa fix fee i proc fee
                // Step 2: Dodaj fiksni fee na vrednost sa forme
                let valueWithFixedFee = parseFloat(enteredAmount) + fixedProvision;
                // Step 3: Izracunaj ukupan iznos sa procentualnom provizijom
                let amountWithProcentualProvision = valueWithFixedFee * 100 / (100 - provisionWithoutDiscountPercent);
                // Step 4: Izracunaj vrednost procentualne provizije kao razliku ukupnog iznosa i iznosa bez procentualne provizije
                let amountOfProcentualProvision = amountWithProcentualProvision - valueWithFixedFee;
                // Step 5: Saberi iznos procentualne provizije i fiksne provizije
                let summedProvisions = amountOfProcentualProvision + fixedProvision;
                // Step 6: Proveriti koja provizija se koristi
                let amountWithMarketFee = 0;
                let amountForMinimalProvision = 0;
                if (minimalProvision > summedProvisions) {
                    // Kreni kalkulaciju ispocetka za min fee
                    // Step 7a: Dodaj minimalnu proviziju na iznos
                    amountForMinimalProvision = parseFloat(enteredAmount) + minimalProvision;
                    // Step 7b: Dodaj market proviziju
                    amountWithMarketFee = amountForMinimalProvision * 100 / (100 - marketFee);
                }
                else {
                    // Step 7e: Dodaj market fee na kraju
                    amountWithMarketFee = amountWithProcentualProvision * 100 / (100 - marketFee);
                }
                // Step 8: Pomnoziti amount sa cenom
                let amountInCoins = amountWithMarketFee / currencyPrice;
                this.txData.amount = this.utilityService.truncateDataBasedOnPrecision(amountInCoins, fixedDecimals);
                // Set fixedFee value
                this.txData.fixedFee = fixedProvision;
            }
            // Buy calculations
            if (what === 'total') {
                // Get values from form and settings
                let currencyPrice = price;
                let fixedProvision = this.fixedFee;
                let feePercent = this.provision;
                let amountFromForm = this.txData.total;
                const result = yield this.feeCalculation(what, event, chainChanged);
                this.minFee = result ? result['fee'] : this.minFee;
                this.minFeeApplied = result ? result['min_fee_applied'] : this.minFeeApplied;
                let minimalProvision = this.minFee;
                let marketFee = this.marketFee;
                let selectPrice = 0;
                // Step 1: ProcenatProvizijeBezPopusta (ProcenatProvizije - ProcenatPopusta)
                let provisionWithoutDiscountPercent = feePercent - discountPercent;
                // Step 2: Proveriti da li je ProcenatProvizijeBezPopusta manji od 0
                if (provisionWithoutDiscountPercent < 0) {
                    provisionWithoutDiscountPercent = 0;
                }
                // Step 3: IznosBezFiskneProvizije (IznosSaForme - FiksnaProvizija)
                let purshaseAmountWithoutFixedProvision = amountFromForm - fixedProvision;
                // Step 4: IznosProcentualneProvizijeNaIznosuBezFiskneProvizije (IznosBezFiskneProvizije/100 * ProcenatProvizijeBezPopusta)
                let provisionPercentAmountWithoutFixedProvision = purshaseAmountWithoutFixedProvision / 100 * provisionWithoutDiscountPercent;
                // Step 5: IznosProvizijaSaFiksnomProvizijom (IznosProcentualneProvizijeNaIznosuBezFiskneProvizije + FiksnaProvizija)
                let provisionAmountWithFixedProvision = provisionPercentAmountWithoutFixedProvision + fixedProvision;
                // Step 6: PrimenjenaProvizija (Vece od UkupnaProvizija ili MinimalnaProvizija)
                let provisionApplied = provisionAmountWithFixedProvision;
                if (minimalProvision > 0) {
                    if (minimalProvision > provisionAmountWithFixedProvision) {
                        provisionApplied = minimalProvision;
                        selectPrice = 1;
                    }
                }
                // Step 7: IznosKupovineBezProvizija (IznosSaForme - PrimenjenIznosProvizije)
                let purshaseAmountWithoutProvisions = amountFromForm - provisionApplied;
                // Step 8: NoviIznos (IznosKupovineBezProvizija / CurrencyPrice)
                let newPurshaseAmount = purshaseAmountWithoutProvisions / currencyPrice;
                // Step 9: IznosMarketProvizije (NoviIznos * (Market Provizija/100))
                let amountOfMarketFee = newPurshaseAmount * marketFee / 100;
                // Step 10: KonacniIznos (NoviIznos - IznosMarketProvizije)
                let finalPurshaseAmount = newPurshaseAmount - amountOfMarketFee;
                // Set price for email
                let priceForEmail = 0;
                if (selectPrice == 0) {
                    // Step 11: CenaZaEmailAkoJeMinimalnaProvizijaManja (IznosBezFiskneProvizije / KonacanIznos )
                    priceForEmail = purshaseAmountWithoutFixedProvision / finalPurshaseAmount;
                }
                else {
                    // Step 11: CenaZaEmailAkoJeMinimalnaProvizijaVeca (IznosSaForme / KonacniIznos)
                    priceForEmail = amountFromForm / finalPurshaseAmount;
                }
                // Set amount for backend
                this.txData.amount = this.utilityService.truncateDataBasedOnPrecision((amountFromForm / price), fixedDecimals);
                // Set amount for screen
                (amountFromForm !== null && amountFromForm > 0) ? this.txData.amountForScreen = this.utilityService.truncateDataBasedOnPrecision(finalPurshaseAmount, fixedDecimals) : this.txData.amountForScreen = 0;
                if (this.txData.amountForScreen <= 0) {
                    this.txData.amountForScreen = 0;
                }
                // Set fixedFee value
                this.txData.fixedFee = fixedProvision;
            }
            // Reverse buy calculations - Still in progress, please ignore logs this time
            if (what === 'buy-reverse') {
                // Get values from form and settings
                let currencyPrice = price;
                let fixedProvision = this.fixedFee;
                let feePercent = this.provision;
                let enteredAmount = this.txData.amountForScreen;
                this.txData.amount = enteredAmount;
                let minimalProvision = this.minFee;
                let marketFee = this.marketFee;
                // Step 0: ProcenatProvizijeBezPopusta (ProcenatProvizije - ProcenatPopusta)
                let provisionWithoutDiscountPercent = feePercent - discountPercent;
                // Step 1: Proveriti da li je ProcenatProvizijeBezPopusta manji od 0
                if (provisionWithoutDiscountPercent < 0) {
                    provisionWithoutDiscountPercent = 0;
                }
                // Pokusaj prvo kakulaciju sa fix fee i proc fee
                // Step 2: Vrati Market Fee da dobijes novi iznos
                let amountWithMarketFee = enteredAmount * 100 / (100 - marketFee);
                // Step 3: Pomnozi sa cenom
                let valueWithMarketFee = amountWithMarketFee * currencyPrice;
                // Step 4: Dodaj procentualnu proviziju
                let valueWithProcentualProvision = valueWithMarketFee * 100 / (100 - provisionWithoutDiscountPercent);
                // Step 5: Saberi iznos procentualne provizije i fiksne provizije
                let valueOfProcentualProvision = valueWithProcentualProvision - valueWithMarketFee;
                // Step 6: Proveriti koja provizija se koristi
                let summedProvisions = valueOfProcentualProvision + fixedProvision;
                let finalAmount = 0;
                // Still not completed, please ingore logs if have in this part
                if (minimalProvision > summedProvisions) {
                    // Step 7a: Dodaj minimalnu proviziju na iznos
                    finalAmount = valueWithMarketFee + minimalProvision;
                }
                else {
                    // Step 7b: Dodaj Fisknu proviziju na kraju
                    finalAmount = valueWithProcentualProvision + fixedProvision;
                }
                // Final Step:  Set amount for backend
                (enteredAmount !== null && enteredAmount !== 0) ? this.txData.total = finalAmount.toFixed() : this.txData.total = 0;
                // Set fixedFee value
                this.txData.fixedFee = fixedProvision;
            }
            this.validateTotalAndAmount();
        });
    }
    feeCalculation(what, event, chainChanged) {
        return __awaiter(this, void 0, void 0, function* () {
            let isNumber = /^[0-9]$/i.test(event.key);
            let isDelete = event.key == 'Delete';
            let isBackspace = event.key == 'Backspace';
            if (this.minFeeMessageVisible && ((isNumber || isDelete || isBackspace) || chainChanged)) {
                this.orderData = {
                    order_type: this.txType,
                    ecurrency: this.currency,
                    mean_of_payment: this.meanOfPayment,
                    chain: this.txData.ecurrencyChain['chain']['name']
                };
                if (what === 'amount') {
                    this.orderData.amount = this.txData.amount;
                    if (this.txData.amount) {
                        const data = yield this.httpClient.post('market/order/checkfee', this.orderData).toPromise();
                        return data;
                    }
                }
                else if (what === 'total') {
                    this.orderData.total = this.txData.total;
                    if (this.txData.total) {
                        const data = yield this.httpClient.post('market/order/checkfee', this.orderData).toPromise();
                        return data;
                    }
                }
            }
        });
    }
    verifyDiscount() {
        return new Promise((resolve) => {
            this.couponValue = 0;
            this.couponOk = false;
            if (this.txData.discount_code) {
                if (this.txData.discount_code.length >= 5) {
                    if (!this.txData.total) {
                        this.txData.total = 0;
                    }
                    this.httpClient.post('market/order/checkdiscountcode', {
                        order_type: this.txType,
                        cryptocurrency: this.currency,
                        discount_code: this.txData.discount_code,
                        amount: this.txData.total,
                        mean_of_payment: this.meanOfPayment
                    }).subscribe((result) => {
                        this.couponError = false;
                        this.couponOk = true;
                        this.couponValue = result['discount'];
                        resolve(true);
                    }, (error) => {
                        this.couponError = true;
                        const message = error.error['message'];
                        const messageSufix = '_' + this.txType.toUpperCase();
                        this.couponMessage = message === 'INVALID_ORDER_TYPE' ? message + messageSufix : message;
                        this.couponLimit = error.error['value'];
                        this.couponLimit = (typeof this.couponLimit !== undefined) ?
                            (Math.round(parseFloat(this.couponLimit + ''))).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.') : '';
                        resolve(false);
                    });
                }
                else if (this.txData.discount_code.length < 5 && this.txData.discount_code.length > 0) {
                    this.couponError = true;
                    this.couponMessage = 'TOO_SHORT';
                    resolve(false);
                }
                else {
                    this.couponError = false;
                    resolve(false);
                }
            }
            else {
                this.couponError = false;
                resolve(false);
            }
        });
    }
    openAddressesSelectBuy() {
        this.activeAccounts = !this.activeAccounts;
        this.activeChains = false;
    }
    openAddressesSelectSell() {
        this.activeAccountsBank = !this.activeAccountsBank;
        this.activeChains = false;
    }
    openChainsSelect() {
        if (this.activeChains && !this.txData.ecurrencyChain) {
            this.chainError = true;
        }
        this.activeChains = !this.activeChains;
        this.activeAccounts = false;
        this.activeAccountsBank = false;
    }
    validateTotalAndAmount() {
        if (typeof this.orderForm !== 'undefined') {
            if (this.txType === 'buy') {
                if (typeof this.txData.total === 'undefined' || this.txData.total > this.maxAmount || this.txData.total < this.minAmount) {
                    this.validTotalAndAmount = false;
                }
                else {
                    this.validTotalAndAmount = true;
                }
                return this.validTotalAndAmount;
            }
            else if (this.txType === 'sell') {
                if (typeof this.txData.amount === 'undefined' || this.txData.amount > this.maxAmount || this.txData.amount < this.minAmount) {
                    this.validTotalAndAmount = false;
                }
                else {
                    this.validTotalAndAmount = true;
                }
                return this.validTotalAndAmount;
            }
        }
        return false;
    }
    validateAddress() {
        return __awaiter(this, void 0, void 0, function* () {
            const address = this.txData.deposit_address;
            this.someoneElsesAddressError = this.someoneElsesAddresses.includes(address);
            const currency = this.currency.toUpperCase();
            if (this.webSettingsService.applySettings('ADDRESS_VALIDATION')) {
                yield this.utilityService.validateAddress(address, currency, this.ecurrencyChains.length > 1 ? this.txData.ecurrencyChain['chain']['name'] : null).then(result => {
                    this.validDepositAddress = result.validDepositAddress;
                });
            }
            else {
                this.validDepositAddress = true;
            }
            return this.validDepositAddress;
        });
    }
    fillData(data, txType) {
        return __awaiter(this, void 0, void 0, function* () {
            if (txType === 'buy') {
                this.txData.deposit_address = data;
                this.validateAddress();
                this.activeAccounts = false;
            }
            else if (txType === 'sell') {
                this.bankAccountValue = this.bankAccountObj.account_name + ' (' + (this.bankAccountObj.bank_account ? this.bankAccountObj.bank_account : this.translateObject.transform('SELL.BANK_ACCOUNT_PENDING_APPROVAL')) + ')';
                this.txData.bank_account = data;
                this.activeAccountsBank = false;
                this.validateBankAccount();
            }
        });
    }
    fillChainData(data, event = null) {
        this.selectedChainName = data.chain.name;
        this.selectedChain = this.selectedChainName + ' - ' + data.chain.description;
        this.txData.ecurrencyChain = data;
        if (this.txType === 'buy') {
            this.cryptoAccountsFiltered = this.cryptoAccounts.filter(account => account.chain_id === data.chain.id);
            if (this.wallets) {
                this.cryptoWallet = null;
                this.wallets.forEach(wallet => {
                    if (this.nameOfCurrency.toUpperCase() === wallet.wallet.currency.symbol && this.txData.ecurrencyChain.chain.name === wallet.wallet.currency.chain.verboseId) {
                        this.cryptoWallet = wallet;
                    }
                });
            }
        }
        this.httpClient.get('market/feesandlimits?is_individual=' + this.isIndividual + '&ecurrency=' + this.nameOfCurrency + '&chain=' + data['chain']['name']).subscribe((data) => {
            this.feesLimits = data;
            const feesForCurrency = this.feesLimits[this.txType][this.nameOfCurrency];
            if (feesForCurrency !== undefined) {
                if (this.activeMeanOfPayment in feesForCurrency) {
                    const activeFees = feesForCurrency[this.activeMeanOfPayment][this.user.user_type_id.type];
                    this.provision = parseFloat(activeFees.fee);
                    this.minAmount = parseFloat(activeFees.min_amount);
                    this.maxAmount = parseFloat(activeFees.max_amount);
                    this.fixedFee = parseFloat(activeFees.fixed_fee);
                    this.minFee = parseFloat(activeFees.min_fee);
                    if (this.activeMeanOfPayment === 'card') {
                        this.orderPaymentTime = parseInt(activeFees.order_payment_time);
                    }
                    this.txData.maxAmount = this.maxAmount;
                    this.txData.minAmount = this.minAmount;
                    this.txData.provision = this.provision;
                }
            }
            if (this.whatLast === 'amount') {
                delete this.txData.total;
                this.onChange('amount', event, true);
            }
            if (this.whatLast === 'total') {
                delete this.txData.amount;
                this.onChange('total', event, true);
            }
        });
        if (this.txData.deposit_address) {
            this.validateAddress();
        }
        this.chainError = false;
        this.activeChains = false;
    }
    getBankAccountSettings(lang) {
        this.webSettingsService.getSettings().subscribe((data) => {
            this.settingsValue = this.webSettingsService.getCustomValue('SELL.BANK_ACCOUNT_FORMAT.VALUE');
        });
    }
    validateBankAccount(value = false) {
        var _a;
        this.someoneElsesAddressError = this.txData.bank_account && this.someoneElsesAddresses.includes((_a = this.txData) === null || _a === void 0 ? void 0 : _a.bank_account);
        if (typeof this.orderForm !== 'undefined') {
            this.checkedIfBankAccountIsValid = true;
            const lang = localStorage.getItem('language');
            this.getBankAccountSettings(lang);
            if (this.whatLast === 'amount') {
                delete this.txData.total;
                this.onChange('amount');
            }
            if (this.whatLast === 'total') {
                delete this.txData.amount;
                this.onChange('total');
            }
            if (this.fiatWallet && this.fiatWallet.wallet.name === value) {
                this.txData.bank_account = this.fiatWallet.wallet.walletProviderWalletId;
                this.validBankAccount = true;
                this.fiatWalletChosen = true;
                return true;
            }
            else if (this.bankAccountObj) {
                this.validBankAccount = true;
                return true;
            }
            const array = this.settingsValue.split('-');
            const startParse = parseInt(array[0]);
            const start = !isNaN(startParse) ? startParse : 0;
            const middleParse = parseInt(array[1]);
            const middle = !isNaN(middleParse) ? middleParse : 0;
            const endParse = parseInt(array[2]);
            const end = !isNaN(endParse) ? endParse : 0;
            this.maxLen = start + middle + end;
            this.maxLenWithSeparators = this.maxLen + 2;
            let numOfDigits;
            const bank_account = this.txData.bank_account;
            if (typeof bank_account !== 'undefined') {
                numOfDigits = this._numberOfDigits(bank_account.replace(/-/g, ''));
            }
            else {
                numOfDigits = 0;
            }
            let tempAccount = '';
            if (typeof bank_account !== 'undefined' && (/^\d+$/.test(this.txData.bank_account.replace(/-/g, '')))) {
                if (numOfDigits < 6) {
                    this.validBankAccount = false;
                }
                else {
                    let howMuch = 0;
                    if ((numOfDigits <= this.maxLen)) {
                        howMuch = (this.maxLen - numOfDigits) + 1;
                    }
                    else {
                        this.txData.bank_account = this.txData.bank_account.substring(0, this.maxLen);
                        howMuch = 0;
                    }
                    tempAccount = new Array(howMuch).join('0');
                    let newAccount = this.txData.bank_account.replace(/-/g, '');
                    newAccount = newAccount.substring(0, start) + tempAccount + newAccount.substring(start, newAccount.length);
                    newAccount = newAccount.substring(0, start) + '-' + newAccount.substring(start, newAccount.length);
                    newAccount = newAccount.substring(0, this.maxLen - 1) + '-' + newAccount.substring(this.maxLen - 1, newAccount.length);
                    this.txData.bank_account = newAccount;
                    if (!this._validFirstThree(newAccount.substring(0, start))) {
                        this.validBankAccount = false;
                        return false;
                    }
                    const firstPart = newAccount.replace(/-/g, '').substring(0, this.maxLen - end);
                    const lastPart = newAccount.replace(/-/g, '').substring(this.maxLen - end, this.maxLen);
                    if (this._mod97(firstPart) === parseInt(lastPart)) {
                        this.validBankAccount = true;
                        this.txData.bank_account = newAccount;
                        return true;
                    }
                    else {
                        this.validBankAccount = false;
                        return false;
                    }
                }
            }
            else {
                this.validBankAccount = false;
                return false;
            }
        }
        return false;
    }
    _mod97(br) {
        let kb = 0;
        let os = 100;
        for (let x = br.length - 1; x >= 0; x--) {
            kb = (kb + (os * parseInt(br.charAt(x), 10))) % 97;
            os = (os * 10) % 97;
        }
        kb = 98 - kb;
        return kb;
    }
    _validFirstThree(value) {
        if (value % 5 === 0) {
            return true;
        }
        return false;
    }
    _numberOfDigits(value) {
        return Math.floor(Math.log(value) / Math.LN10 + 1);
    }
    closeSelect() {
        this.activeAccounts = false;
        this.activeAccountsBank = false;
    }
    closeSelectEcurrencyChains() {
        this.activeChains = false;
    }
    getData() {
        return this.txData;
    }
    shouldSaveMethod() {
        return this.shouldSave;
    }
    getLotSizeIfMarketIsBinance() {
        this.httpClient.get('market/getallowednumberofdecimals/' + this.nameOfCurrency + '/' + this.txType).subscribe((data) => {
            this.allowedDecimalPlaces = data['lotSize'] != null ? data['lotSize'] : this.defaultDecimalPlaces;
            for (let i = 1; i <= this.allowedDecimalPlaces; i++) {
                this.decimalStep += i != this.allowedDecimalPlaces ? '0' : '1';
            }
        }, (error) => {
            this.allowedDecimalPlaces = this.defaultDecimalPlaces;
        });
    }
    allowDecimalPoints(event, lotSize) {
        if (lotSize > 0) {
            const splitVal = event.target.value.split('.');
            if (splitVal.length === 2 && splitVal[1].length >= lotSize) {
                const isNumber = /^[0-9]$/i.test(event.key);
                if (isNumber) {
                    event.preventDefault();
                }
            }
        }
        else if (lotSize === 0) {
            if (event.key === ".") {
                event.preventDefault();
            }
        }
    }
    getWallets() {
        if (this.user.personally_validated && this.user.api_mfa_enabled == 1) {
            this.httpClient.get('wallet/getwallets').subscribe((data) => {
                this.wallets = data['wallets'];
                if (this.wallets) {
                    this.wallets.forEach(wallet => {
                        if (this.nameOfCurrency.toUpperCase() === wallet.wallet.currency.symbol && wallet.wallet.currency.defaultChain) {
                            this.cryptoWallet = wallet;
                        }
                        if (wallet.wallet.currency.fiat === true && wallet.wallet.currency.verboseId === this.defaultCurrency) {
                            this.fiatWallet = wallet;
                        }
                    });
                }
            });
        }
    }
    onBankAccountModelChange(value) {
        this.fiatWalletChosen = false;
        this.txData.bank_account = value;
    }
    addNewBankAccount() {
        this.activeAccountsBank = false;
        this.compService.openModal(BankaccountWhitelistInfoExchangeComponent, {
            pendingProcess: this.bankAccounts.some(account => account.status === this.waitingForApprovalStatus),
        });
    }
};
OrderFormComponent.ctorParameters = () => [
    { type: SharedHttp },
    { type: WebClientService },
    { type: WebsiteThemeService },
    { type: DomSanitizer },
    { type: Router },
    { type: QrScannerModalService },
    { type: ComponentService },
    { type: DeviceDetectorService },
    { type: ChangeDetectorRef },
    { type: AuthService },
    { type: UtilityService },
    { type: TranslateObjectPipe }
];
__decorate([
    ViewChild('orderForm', { static: true })
], OrderFormComponent.prototype, "orderForm", void 0);
__decorate([
    Input()
], OrderFormComponent.prototype, "isGuest", void 0);
__decorate([
    Input()
], OrderFormComponent.prototype, "txType", void 0);
__decorate([
    Input()
], OrderFormComponent.prototype, "currency", void 0);
__decorate([
    Input()
], OrderFormComponent.prototype, "meanOfPayment", void 0);
__decorate([
    Input()
], OrderFormComponent.prototype, "provision", void 0);
__decorate([
    Input()
], OrderFormComponent.prototype, "fixedFee", void 0);
__decorate([
    Input()
], OrderFormComponent.prototype, "minFee", void 0);
__decorate([
    Input()
], OrderFormComponent.prototype, "minAmount", void 0);
__decorate([
    Input()
], OrderFormComponent.prototype, "maxAmount", void 0);
__decorate([
    Input()
], OrderFormComponent.prototype, "orderPaymentTime", void 0);
__decorate([
    Input()
], OrderFormComponent.prototype, "cryptoAccounts", void 0);
__decorate([
    Input()
], OrderFormComponent.prototype, "bankAccounts", void 0);
__decorate([
    Input()
], OrderFormComponent.prototype, "nameOfCurrency", void 0);
__decorate([
    Input()
], OrderFormComponent.prototype, "activeMeanOfPayment", void 0);
__decorate([
    Input()
], OrderFormComponent.prototype, "appliedFee", void 0);
__decorate([
    Input()
], OrderFormComponent.prototype, "ecurrencyChains", void 0);
__decorate([
    Input()
], OrderFormComponent.prototype, "numOfChains", void 0);
__decorate([
    Input()
], OrderFormComponent.prototype, "someoneElsesAddressError", void 0);
__decorate([
    Input()
], OrderFormComponent.prototype, "price", void 0);
__decorate([
    HostListener('window:resize', ['$event'])
], OrderFormComponent.prototype, "onResize", null);
OrderFormComponent = __decorate([
    Component({
        selector: 'ecd-order-form',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./order-form.component.html")).default,
        providers: [TranslateObjectPipe]
    }),
    Directive({ selector: 'orderForm' })
], OrderFormComponent);
export { OrderFormComponent };
